import constants from 'constants/index'

const subcategoryName = (subCategoryId) => {
  return constants.complaint.COMPLAINT_SUBCATEGORIES.find(
    (subCategory) => subCategory.id === subCategoryId,
  )?.name
}

export default subcategoryName
